import { css } from "lit";
export default css `
   a {
         color: var(--primary-color);
         text-decoration: none;
   }
    a:hover {
        color: var(--primary-color);
        text-decoration: underline;
    }
    a:visited {
        color: var(--primary-color);
    }
    a:active {
        color: var(--primary-color);
    }
`;
